export { default } from './MorePosts';
